module.exports = __webpack_public_path__ + "img/selected5-min.8d77a726.png";